import(/* webpackMode: "eager", webpackExports: ["MainLayout"] */ "/vercel/path0/components/layout/MainLayout.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguagePills"] */ "/vercel/path0/components/site/LanguagePills.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
